module.exports = __webpack_public_path__ + "static/media/british-museum-glass-roof.04e4e16c.jpg";